// extracted by mini-css-extract-plugin
module.exports = {"input":"text-area_input__34mEa"};